import { Pipe, PipeTransform } from '@angular/core';
import { EmptyCheckInStatus } from '@services';

@Pipe({
    name: 'emptyCheckInStatus',
    standalone: true,
})
export class EmptyCheckInStatusPipe implements PipeTransform {
    transform(value: EmptyCheckInStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case EmptyCheckInStatus.EmptyRequired: return 'Empty - Required';
            case EmptyCheckInStatus.EmptyNotRequired: return 'Empty - Not Required';
            case EmptyCheckInStatus.ShuntMovePending: return 'Shunt Move Pending';
            case EmptyCheckInStatus.OutboundEmpty: return 'Outbound Empty';
            case EmptyCheckInStatus.Loading: return 'Loading';
            case EmptyCheckInStatus.OutboundLoaded: return 'Outbound Loaded';
            case EmptyCheckInStatus.Loaded: return 'Loaded';
            default:
                return value;
        }
    }
}